const flagsToBinary = arr => arr.reduce((a, b) => a ^ b, 0)

export default flagsToBinary;